const ImageListSection = ({title, items, image, imageSide, showImageInMobile}) => {

  const img = (<img className="image-list-section-image" alt={title} src={image} loading="lazy"/>);
  const imgMobile = (<img className="image-list-section-image-mobile" alt={title} src={image} loading="lazy"/>);

  return (
    <div className="image-list-section-container">
      {imageSide === "left" && img}

      <div className="image-list-section-list">
        <h2>{title}</h2>
        <ul> {items.map((item, index) => ( <li key={index}>{item}</li> ))} </ul>
      </div>

      {imageSide === "right" && img}

      {showImageInMobile && imgMobile}
    </div>
  );
};

export default ImageListSection;
